module.exports = __webpack_public_path__ + "static/media/message-golden.a77b43ee.svg";